import React from "react";
import Footer from "../components/Footer";
import logoImage from "../assets/logo.png"

function Navbar() {
    return (
      <header className="bg-white shadow-md fixed top-0 left-0 w-full z-50">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="text-xl font-bold text-primary">
            <img src={logoImage} alt="Logo Image" className="w-[100px] h-[80px]"/>
          </h1>
          {/* <nav className="hidden md:flex space-x-6">
            <a href="#fitur" className="text-textmain hover:text-primary font-medium">Fitur</a>
            <a href="#daftar" className="text-textmain hover:text-primary font-medium">Daftar</a>
          </nav> */}
          <div className="space-x-2 hidden md:flex">
            <a href="/login">
              <button className="border border-primary text-primary px-4 py-1 rounded-full hover:bg-primary hover:text-white transition">Masuk</button>
            </a>
            {/* <button className="bg-primary text-white px-4 py-1 rounded-full hover:bg-accent transition">Daftar</button> */}
          </div>
        </div>
      </header>
    );
  }

export default function ConsultationPage () {
    return(
      <div className="min-h-screen bg-secondary text-textmain font-sans pt-20">
        <Navbar />
        <div className="relative max-w-6xl mx-auto pt-12 px-0 pb-3">
          <h2 className="text-3xl font-bold mb-3 text-center">Form Konsultasi Gratis</h2>
          <p className="text-lg mb-6 max-w-xl mx-auto text-center">
            Masih ragu? Ikuti konsultasi gratis untuk mendapatkan kelas yang sesuai dengan kebutuhanmu.
          </p>
          <iframe 
            src="https://docs.google.com/forms/d/e/1FAIpQLSeD9daTqVx43wIGWJcxZH3Cy4RBb1KU2d5eDgdT7dTkVLw_ew/viewform?embedded=true"
            width="100%"
            height="1000"
          >
            Memuat…
          </iframe>
        </div>  
        <Footer />
      </div>
    )
}